import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refreshProfile } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        // Supabase will pick up the OAuth/magic link query/hash automatically when
        // detectSessionInUrl: true. Just wait for the session.
        let attempts = 0;
        let session = null;
        while (attempts < 12) {
          const { data } = await supabase.auth.getSession();
          if (data.session) {
            session = data.session;
            break;
          }
          await new Promise((r) => setTimeout(r, 250));
          attempts += 1;
        }
        if (!session) {
          setError("Authentication timed out. Try again.");
          setTimeout(() => navigate("/login"), 1500);
          return;
        }
        // Ensure backend profile exists & is fresh
        try {
          await api.get("/profile");
        } catch (_) {
          /* server may be cold-starting; backend creates profile on first call */
        }
        await refreshProfile();
        const promo = params.get("promo");
        if (promo) {
          try {
            await api.post("/promo/redeem", { code: promo });
            await refreshProfile();
          } catch (_) {
            /* swallow — user can retry from /pricing */
          }
        }
        const plan = params.get("plan");
        if (plan === "starter" || plan === "pro") {
          try {
            const { data } = await api.post("/billing/create-checkout", { tier: plan });
            window.location.href = data.url;
            return;
          } catch (_) {
            /* fall through to dashboard */
          }
        }
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(e.message || "Something went wrong");
        setTimeout(() => navigate("/login"), 1500);
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-7 h-7 animate-spin text-[#534AB7] mx-auto" strokeWidth={1.5} />
        <p className="mt-4 text-sm text-[#5F5E5A]">{error || "Finishing sign in…"}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
